"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyObject = void 0;
const effect_1 = require("effect");
exports.EmptyObject = effect_1.Schema.Record({ key: effect_1.Schema.Never, value: effect_1.Schema.Never });
//# sourceMappingURL=_util.js.map